const utmKeyMap = {
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
  utmTerm: 'utm_term',
  utmRegion: 'utm_region',
  utmLifecycle: 'utm_lifecycle',
  utmAudience: 'utm_audience',
  utmSeries: 'utm_series',
  utmCountry: 'utm_country',
  utmPartner: 'utm_partner',
  utmLang: 'utm_lang',
  utmAuthServiceUuid: 'utm_authserviceuuid',
};
export const sessionStorageKeys = Object.values(utmKeyMap);
const sessionStorageKeyMap = { ...utmKeyMap, journeySessionUuid: 'journey_session_uuid' };

export const getSessionTrackingData = () => {
  let sessionTrackingData = {};

  if (window.sessionStorage) {
    sessionTrackingData = Object.entries(sessionStorageKeyMap).reduce<{ [key: string]: string | null }>(
      (acc, [key, value]) => {
        if (window.sessionStorage.getItem(value)) {
          acc[key] = window.sessionStorage.getItem(value);
        }

        return acc;
      },
      {}
    );
  }

  return sessionTrackingData;
};

export const removeSessionTrackingData = () => {
  if (window.sessionStorage) {
    Object.values(sessionStorageKeyMap).forEach((value) => {
      window.sessionStorage.removeItem(value);
    });
  }
};
